import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { Subscription } from 'rxjs';

import {
  DeviceService, SdBannerComponent, SdHtmlComponent, SdLinkComponent, SdModalDefaultComponent, SdTitleComponent
} from '@seb/web-design-system/core';

import type { ITileModal } from './tile-modal.interface';

@Component({
  selector: 'sd-tile-modal',
  templateUrl: './tile-modal.component.html',
  styleUrls: ['./tile-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdModalDefaultComponent,
    SdTitleComponent,
    SdBannerComponent,
    SdLinkComponent,
    SdHtmlComponent
  ]
})
export class SdTileModalComponent implements OnInit, OnDestroy {
  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
  ) {}

  mobileSubscription: Subscription;
  tabletSubscription: Subscription;
  isMobile$: boolean;
  isTablet$: boolean;

  /**
   * Manage the opening and closing of the modal
   */
  @Input()
  isOpened = false;

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Input()
  tileModal: ITileModal;

  @Input()
  tileTitleLevel = 3;

  @Output()
  videoPlayed = new EventEmitter<{ status: string; title: string }>();

  @Output()
  videoEnded = new EventEmitter<{ status: string; title: string }>();

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
    this.tabletSubscription = this.deviceService.isTablet.subscribe((x) => {
      this.isTablet$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
    this.tabletSubscription?.unsubscribe();
  }

  onVideoPlayed(title) {
    this.videoPlayed.emit({ status: 'play', title });
  }

  onVideoEnded(title) {
    this.videoEnded.emit({ status: 'ended', title });
  }
}
